import React, { useEffect,useState } from "react";
import { GlobalState } from "../../../../redux/root-reducer";
import { Dispatch } from "redux";
import { IFetchScorePayload } from "../../../../redux/score/score.actions";
import { fetchApi } from "../../../../redux/fetch/fetch.actions";
import { connect } from "react-redux";
import { User } from "../../../../@types/user.interface";
import { useRouteMatch } from "react-router-dom";
import { IFetchQuizPayload } from "../../../../redux/quiz/quiz.actions";
import QuestionActionAPI, {
    IFetchQuestionsPayload,IFetchQuestionAnswerPayload
} from "../../../../redux/question/question.actions";
import { Quiz } from "../../../../@types/quiz.interfaces";
import ResultImage from "../../../../assets/images/svg/undraw_quiz_nlyh.svg";
import {QuestionDiscussion } from "../../../../@types/question.interface";
import DiscussionAnswer from '../../../../components/discussion-answer/discussion-answer.component';
import "./score-page.styles.scss";

interface IProps {
    isFetching?: boolean;
    isFetching2?: boolean;
    isFetching3?: boolean;
    error?: string;
    error2?: string;
    user: User | null;
    quiz: Quiz | null;
    score: number | null;
    fetchQuiz: (data: IFetchQuizPayload["data"]) => void;
    fetchScore: (data: IFetchScorePayload["data"]) => void;
    question_and_answer: QuestionDiscussion[] | null;
    fetchQuestions: (id: number) => void;
    clearQuestionDiscussion: () => void;
}
function ScorePageContainer({
    isFetching,
    isFetching2,
    isFetching3,
    error,
    user,
    score,
    quiz,
    question_and_answer,
    fetchQuestions,
    fetchQuiz,
    fetchScore,
    clearQuestionDiscussion
}: IProps) {
    const match = useRouteMatch<{ id: string }>();
    const id = parseInt(match.params.id);

    useEffect(() => {
            clearQuestionDiscussion();
            fetchQuestions(id);
        }, [isFetching3, fetchQuestions, id]);
    useEffect(() => {
        if (isFetching || isFetching2 || error) return;
        if (user !== null) {
            if (score === null && user.email_address) {
                fetchScore({
                    quiz_id: id,
                    email_address: user.email_address,
                });
            }
            if (quiz === null)
                fetchQuiz({
                    id: id,
                });
        }
    }, [
        score,
        isFetching,
        isFetching2,
        error,
        user,
        quiz,
        fetchQuiz,
        fetchScore,
        id,
    ]);


    return (
        
        <div className="container">
            <div className="container__content">
                <div className="score-page">
                    <div className="score-page__title">
                        <h2 className="heading">Score</h2>
                    </div>
                    <div className="score-page__detail">
                        <div className="score-page__detail__image">
                            <img src={ResultImage} alt="ResultImage" />
                        </div>
                        <div className="score-page__detail__result">
                            <h2>Result</h2>
                            <p>Course : {quiz?.courses.course_name}</p>
                            <p>Duration : {quiz?.quiz_duration} Minutes</p>
                            <p>Your Score : {score}</p>
                        </div>
                    </div>
                    <div className="score-page__detail__discussion">
                            {question_and_answer?.map((question, index) => {
                                return (
                                    <DiscussionAnswer question={question} index={index}/>
                                )
                                
})}
                        </div>
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
    user: { self },
    quiz: { quiz },
    score: { score },
    question: {question_answer},
}: GlobalState) => ({
    isFetching: isFetching.SCORE,
    isFetching3: isFetching.QUESTIONS,
    errors: errors.SCORE,
    isFetching2: isFetching.QUIZ,
    errors2: errors.QUIZ,
    user: self.data,
    quiz,
    score,
    question_and_answer: question_answer
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    fetchQuiz: (data: IFetchQuizPayload["data"]) =>
        dispatch(fetchApi({ name: "QUIZ", data: data })),
    fetchScore: (data: IFetchScorePayload["data"]) =>
        dispatch(fetchApi({ name: "SCORE", data: data })),
    fetchQuestions: (id: IFetchQuestionAnswerPayload["data"]["id"]) =>
        dispatch(fetchApi({ name: "QUESTIONS_DISCUSSION", data: { id } })),
    clearQuestionDiscussion: () => dispatch(QuestionActionAPI.clearQuestionDiscussion()),
    
});

const ScorePage = connect(
    mapStateToProps,
    mapDispatchToProps
)(ScorePageContainer);

export default ScorePage;
